var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',[_c('h1',{staticClass:"page-title text-center mt-5"},[_vm._v("Attaching email to JDE")]),_c('v-row',[_c('v-col',{staticClass:"center mt-5"},[(_vm.isLoading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }